import {Injectable} from '@angular/core';
import {NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES = {
  'fr': {
    weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
    months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
    weekLabel: 'sem'
  },
  'en': {
      weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  }
  // other languages you would support
};

@Injectable()
export class datepickerI18n extends NgbDatepickerI18n {
  currentLang: string;
  constructor() { 
      super();
      this.currentLang = sessionStorage.getItem("currLang") 
     
   }

  getWeekdayLabel(weekday: number): string { return I18N_VALUES[this.currentLang].weekdays[weekday - 1]; }
  getMonthShortName(month: number): string { return I18N_VALUES[this.currentLang].months[month - 1]; }
  getMonthFullName(month: number): string { return this.getMonthShortName(month); }
  getDayAriaLabel(date: NgbDateStruct): string { 
    let selectedMonth : any = `${date.month}`;
    var month = I18N_VALUES[this.currentLang].months[selectedMonth- 1]; 
    return `${date.day}`+"-"+month+"-"+`${date.year}`; }
}